/** One-item-per-line input for the name and term pickers: trimmed, no blanks, no repeats. */

const LINE_BREAK = /\r?\n/;

export interface LineList {
  items: string[];
  /** Non-blank lines dropped because an earlier line was the same (ignoring case and edge spaces). */
  removed: number;
}

/** Splits text into trimmed non-blank lines and drops repeats, keeping the first spelling. */
export function parseLineList(text: string): LineList {
  const seen = new Set<string>();
  const items: string[] = [];
  let removed = 0;
  for (const raw of text.split(LINE_BREAK)) {
    const line = raw.trim();
    if (line.length === 0) {
      continue;
    }
    const key = line.normalize("NFC").toLowerCase();
    if (seen.has(key)) {
      removed += 1;
    } else {
      seen.add(key);
      items.push(line);
    }
  }
  return { items, removed };
}
